import { useEffect, useState } from 'react';

export default function PontosToast({ pontos, label, onDismiss }) {
  var [visible, setVisible] = useState(false);

  useEffect(function() {
    var t1 = setTimeout(function() { setVisible(true); }, 10);
    var t2 = setTimeout(onDismiss, 3200);
    return function() { clearTimeout(t1); clearTimeout(t2); };
  }, [onDismiss]);

  return (
    <div
      onClick={onDismiss}
      style={{
        position: 'fixed',
        top: visible ? 20 : -80,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2000,
        background: 'var(--primary)',
        color: '#fff',
        borderRadius: 'var(--r-full)',
        padding: '11px 24px',
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        boxShadow: '0 4px 24px rgba(0,0,0,0.22)',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        transition: 'top 0.35s cubic-bezier(0.34, 1.56, 0.64, 1)',
      }}
    >
      <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '1rem', fontWeight: 700 }}>
        +{pontos} pontos
      </span>
      {label && (
        <span style={{ fontFamily: "'DM Sans', sans-serif", fontSize: '0.82rem', opacity: 0.85 }}>
          · {label}
        </span>
      )}
    </div>
  );
}
